import styled from 'styled-components';

const FallbackLayer = styled.div.attrs({
    className: 'fallback-layer',
})`
    position: 'fixed';
    top: 0;
    left: 0;
    width: '100%';
    height: '100%';
`;

export default FallbackLayer;
